import { Text } from "@mantine/core";
import { L2KTextProps } from "./types";
import { TEXT_STYLES, COLORS } from "./constants";

/**
 * L2KText - Body text component with size variants
 * Uses Public Sans font
 * Sizes: xs (12-14px), sm (14-16px), md (16-18px), lg (18-22px), xl (20-24px)
 */
export function L2KText({
  children,
  size = "md",
  variant = "primary",
  style,
  ...props
}: L2KTextProps) {
  // Get the text style based on size
  const textStyle = TEXT_STYLES[size];

  // Get color based on variant (no gradient support for text)
  const color = COLORS[variant];

  return (
    <Text
      style={{
        fontSize: textStyle.fontSize,
        lineHeight: textStyle.lineHeight,
        letterSpacing: textStyle.letterSpacing,
        fontWeight: textStyle.fontWeight,
        fontFamily: textStyle.fontFamily,
        color: color,
        margin: 0,
        ...style,
      }}
      {...props}
    >
      {children}
    </Text>
  );
}
